import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "../../theme/customTheme";

export const useRichTextFieldStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
    width: "100%",
    boxSizing: "border-box",
  },
  editorWrapper: {
    display: "flex",
  },
  editor: {
    backgroundColor: designTokens.neutral[50],
    width: "100%",
    height: "100px",
    position: "relative",
  },
});
